import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

api.interceptors.request.use(config => {
  config.headers = config.headers || {};
  config.headers['Cache-Control'] = 'no-cache';
  config.headers['Pragma'] = 'no-cache';
  config.headers['Expires'] = '0';

  if (config.method && config.method.toLowerCase() === 'get') {
    config.params = { ...(config.params || {}), _ts: Date.now() };
  }

  return config;
});

export default api;
